export const NAVIGATION_MENU_EXPANDED_WIDTH = 218;
export const NAVIGATION_MENU_CLOSED_WIDTH = 48;

export const NAVIGATION_MENU_WIDTH_VAR = '--lely-navigation-menu-width';

// Falls back to 0 when the navigation menu is not rendered
export const NAVIGATION_MENU_OFFSET = `var(${NAVIGATION_MENU_WIDTH_VAR}, 0px)`;
